export default __webpack_public_path__ + "static/media/standard.9457793d.svg";